import { SingleNotification } from '@spinwise/react-component-library/SingleNotification';
import { useEffect, useState } from 'react';
import { IApplicationState, INotificationReduxData } from '@spinwise/spinwise-core';
import { useSelector } from 'react-redux';
import Link from 'Components/shared/Link/Link';
import styles from './ToastNotificationManager.module.scss';
import { mapCoreIconInterface, mapCoreNotificationDestination } from '../../../../libraryShared/notifications';
import { basicListener } from 'src/channels/basic.channel';
import { t } from 'i18next';
import { Trans } from 'react-i18next';
import { EBasicOverlays } from 'Components/shared/Overlay/elements/BasicOverlayManager/types';
export enum ELocalStorageNotificationsKeys {
  TOAST = 'tnotify',
  NOTIFY = 'notify',
}

export const ToastNotificationManager = () => {
  const newNotificationMessage = useSelector(
    (state: IApplicationState) => state.accountReducer?.newNotify?.notifications?.message,
  );
  const [isNotificationsBellOpen, setIsNotificationsBellOpen] = useState(false);

  useEffect(() => {
    const sub = basicListener.subscribe((dataOverlay: any) => {
      if (!dataOverlay?.data) {
        setIsNotificationsBellOpen(false);
        return;
      }

      const isOpen = dataOverlay.data?.content?.type == EBasicOverlays.NotificationsList;

      if (isOpen == true) {
        setIsNotificationsBellOpen(isOpen);
        onCloseToast();
      }
    });

    return () => sub.unsubscribe();
  }, []);

  useEffect(() => {
    if (isNotificationsBellOpen == true) return;

    const dataArr: Array<INotificationReduxData> = newNotificationMessage?.filter(
      el => getLocalstorageNotify()?.includes(el?.eid) == false,
    );

    if (!dataArr) return;
    if (dataArr?.length == 0) return;
    //show only important notifications
    const importantFirst = dataArr?.find(el => el?.isImportant == true);
    if (!importantFirst) return;

    const messages = newNotificationMessage;
    setNotificationData({
      ...importantFirst,
      countLayers: messages.length > 3 ? 3 : messages.length,
    });
  }, [newNotificationMessage]);

  const [notificationData, setNotificationData] = useState<INotificationReduxData & { countLayers: number }>(null);

  const [isVisible, setIsVisible] = useState<boolean>(false);
  const [timer, setTimer] = useState<any>({
    start: true,
    step: 0.5,
    time: 15,
    onTimerEnd: (notify: Array<string>) => {
      onCloseToast();
    },
  });

  useEffect(() => {
    if (isVisible == true) setTimer({ ...timer, start: true });
  }, [isVisible]);

  const addToLocalStorageAsShown = () => {
    const notifyInStorage = localStorage.getItem?.(ELocalStorageNotificationsKeys.NOTIFY)?.toString() ?? '';
    localStorage?.setItem?.(ELocalStorageNotificationsKeys.TOAST, notifyInStorage);
  };

  const getLocalstorageNotify = (): Array<string> => {
    return localStorage.getItem?.(ELocalStorageNotificationsKeys.TOAST)?.toString()?.split(',') ?? [];
  };

  useEffect(() => {
    if (!notificationData || notificationData === null) return;
    setIsVisible(true);
  }, [notificationData]);

  const onCloseToast = () => {
    setTimer({ ...timer, start: false });
    setIsVisible(false);
    setTimeout(() => {
      addToLocalStorageAsShown();
    }, 200); //animation time
  };
  const getSingleNotification = () => {
    if (localStorage?.getItem?.(ELocalStorageNotificationsKeys.TOAST)?.toString().includes(notificationData?.eid))
      return <></>;
    return (
      <SingleNotification
        notificationElement={{
          id: notificationData.eid,
          title: notificationData?.title ?? '',
          //@ts-ignore
          time: (
            <Trans
              //@ts-ignore
              components={{
                DATE: notificationData?.time?.value,
              }}
            >
              {`short.time.${notificationData?.time.t_key}`}
            </Trans>
          ) as string,
          data: newNotificationMessage?.map(m => m?.eid) ?? [],
          description: notificationData?.description ?? '',
          onClickClose: (notify: Array<string>) => {
            onCloseToast();
          },
          onClickAction: () => {},
          actionButtonText: t(`notification.action.${notificationData.notification_code}`),
          timer: timer,
          icon: mapCoreIconInterface(notificationData.icon),
          ...(notificationData.destination != ''
            ? {
                link: {
                  LinkElement: Link,
                  href: mapCoreNotificationDestination(notificationData.destination),
                },
              }
            : {}),
        }}
        layerCount={notificationData.countLayers as 1 | 2 | 3}
      ></SingleNotification>
    );
  };
  return (
    <>
      {notificationData && (
        <div
          onClick={() => {
            onCloseToast();
          }}
          className={`${styles.toast_container} ${
            isVisible == true ? styles.toast_container_visible : styles.toast_container_hidden
          }`}
        >
          {getSingleNotification()}
        </div>
      )}
    </>
  );
};
